// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#9AA0C1","subMenuActiveText":"#9AA0C1","menuBg":"#121426","menuHover":"#585b73","subMenuBg":"#393D58","subMenuHover":"#585b73","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 76